// extracted by mini-css-extract-plugin
export var container = "_5m-0";
export var fallback = "_5m-5";
export var fallbackIcon = "_5m-6";
export var hidden = "_5m-2";
export var image = "_5m-3";
export var loaded = "_5m-4";
export var placeholder = "_5m-1";